var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckDoneGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.71232 7C3.62315 7 3.53707 6.98454 3.45408 6.95361C3.37108 6.92269 3.2888 6.8708 3.20723 6.79793L0.173766 4.08842C0.0542525 3.98167 -0.00361131 3.85289 0.000174347 3.70208C0.00397234 3.55127 0.065628 3.4225 0.185141 3.31574C0.304655 3.20898 0.446938 3.1556 0.61199 3.1556C0.77703 3.1556 0.919307 3.20898 1.03882 3.31574L3.74931 5.73677L9.99267 0.160143C10.1122 0.0533808 10.2502 0 10.4067 0C10.5632 0 10.7012 0.0533808 10.8207 0.160143C10.9402 0.266893 11 0.390165 11 0.529959C11 0.669752 10.9402 0.793025 10.8207 0.899776L4.21741 6.79793C4.13583 6.8708 4.05355 6.92269 3.97055 6.95361C3.88756 6.98454 3.80148 7 3.71232 7Z",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDoneGray);
export default __webpack_public_path__ + "static/media/check_done_gray.d7604111e08c0a6af601f34fbdbb9001.svg";
export { ForwardRef as ReactComponent };